<template>
  <div :class="`m-1 rounded-full shadow cursor-pointer place-items-center grid grid-cols-1 ${selected ? 'bg-gradient-to-br from-primary-400 to-primary-500' : 'bg-white'}`" style="width: 30px; height: 30px" v-tooltip="`${tt}`">


      <font-awesome-icon :icon="icon" :class="selected ? 'text-white' : 'text-primary'" size="sm"></font-awesome-icon>

  </div>
</template>

<script setup="props">
// Setup prop
const props = defineProps({
  selected: Boolean,
  icon: String,
  tt: String
});
</script>p-2 
